import styled, { css } from "styled-components";

const commonStyles = css`
  display: contents;
  .containerFreteGratis {
    padding: 0 10%;
    width: 100rem;
    max-width: 90vw;
    position: relative;
    .inputContainer {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 0rem 0 1rem 0;
    }

    .containerToggles {
      padding: 2rem 0rem ;
      display: flex;
      flex-direction: column;
      align-items: start;

      .containerTogglesInner {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .containerToggleConfigurar {
          display: grid;
          grid-template-columns: 45% repeat(2, 1fr);
          .nome {
            color: ${(props) => props.theme.colors.tertiary};
          }
        }
      }
    }

    .exclusao {
      padding: 4rem 0;
      text-align: center;
      color: ${(props) => props.theme.colors.primary};
      cursor: pointer;
    }
  }
`;

export const ContainerFreteGratis = styled.div<{
  configIn: "empresa" | "configuracoes";
}>`
  ${commonStyles}
  ${({ configIn }) =>
    configIn === "configuracoes" &&
    css`
      .containerFreteGratis {
        width: 100%;
        max-width: none;
        padding: 3rem 0;
        .inputContainer {
          width: 100%;
          padding: 0;
          &::after {
            display: none;
          }
        }
        .containerToggles {
          padding: 4rem 0rem;
          flex-direction: row;
          align-items: start;
          .containerTogglesInner {
            .containerToggleConfigurar {
              .nome {
                width: auto;
                margin-right: 1rem;
              }
            }
          }
        }
        .exclusao {
          margin-top: 0;
          padding: 2rem 0 0 0;
          text-align: center;
        }
      }
    `}
`;
